import { useTranslation } from 'react-i18next';
import { useGetRequiredRule } from '@/hooks';
import { useGetNumbersOnlyRule, useGetSlugRule } from '../../../shared/hooks/formValidations';
import { EditCategoryFieldNames } from '../helpers/types';

export const useEditCategoryValidationRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const slugRule = useGetSlugRule({ t });
  const numbersOnlyRule = useGetNumbersOnlyRule({ t });

  return {
    [EditCategoryFieldNames.LOCALE]: [requiredRule],
    [EditCategoryFieldNames.SLUG]: [requiredRule, slugRule],
    [EditCategoryFieldNames.GOOGLE_FEED_ID]: [requiredRule, numbersOnlyRule],
  };
};
